import {Component, Input, OnDestroy} from '@angular/core';
import {MapTileLayerSettingsService} from '../../../map-settings/map-services/map-tile-layer-settings.service';
import * as L from 'leaflet';

@Component({
  selector: 'app-map-lat-lng-view',
  templateUrl: './map-lat-lng-view.component.html',
  styleUrls: ['./map-lat-lng-view.component.scss']
})
export class MapLatLngViewComponent implements OnDestroy {
  @Input() latLng: [number, number];
  @Input() iconClass: string;
  private map: L.Map | null = null;
  private marker: L.Marker | null = null;

  leafletOptions = {
    layers: [this.mapTileLayerSettingsService.currentTileLayer.getValue()],
    zoom: 14,
    zoomControl: false,
    attributionControl: false
  };

  constructor(
    private mapTileLayerSettingsService: MapTileLayerSettingsService
  ) {
  }

  get getCoordinates(): L.LatLng {
    return L.latLng(this.latLng[0], this.latLng[1]);
  }

  getIcon() {
    return L.divIcon({
      className: this.iconClass ? this.iconClass : 'icon ic-map-pin_default',
      iconSize: [24, 24],
      iconAnchor: [12, 24],
      shadowSize: [0, 0]
    });
  }

  onMapReady(lMap: L.Map) {
    this.map = lMap;
    this.marker = L.marker(this.latLng, {icon: this.getIcon()}).addTo(this.map);
    setTimeout(() => {
      this.map.invalidateSize();
    }, 0);
  }


  ngOnDestroy() {
    if (this.marker) {
      this.marker.remove();
      this.marker = null;
    }
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }
}

